import { useState } from 'react';
import { Card, Switch, FormField, Button, useToast } from '@afrilink/ui';

interface Pref {
  key: string;
  label: string;
  description: string;
  defaultOn: boolean;
}

const PREFS: Pref[] = [
  { key: 'invoice_issued',  label: 'Invoice issued',     description: 'When a new invoice is generated.', defaultOn: true },
  { key: 'invoice_due',     label: 'Invoice due soon',   description: 'Reminder 5 days before the due date.', defaultOn: true },
  { key: 'invoice_overdue', label: 'Invoice overdue',    description: 'When an invoice goes past due.', defaultOn: true },
  { key: 'payment_received', label: 'Payment received',  description: 'Receipt for every successful payment.', defaultOn: true },
  { key: 'service_alert',   label: 'Service alerts',     description: 'Suspensions, terminations, capacity warnings.', defaultOn: true },
  // 2026-09-25: this said "60 / 30 / 7 days" for five months while nothing
  // sent any of them. The copy now describes what billing-cron actually does.
  { key: 'domain_expiring', label: 'Domain expiring',    description: 'Renewal invoice 30 days before expiry, and a reminder 7 days before if it is still unpaid.', defaultOn: true },
  { key: 'product_news',    label: 'Product news',       description: 'Occasional updates about new features.', defaultOn: false },
];

export default function SettingsNotificationsPage() {
  const { toast } = useToast();
  const [state, setState] = useState<Record<string, boolean>>(
    Object.fromEntries(PREFS.map((p) => [p.key, p.defaultOn]))
  );
  const [saving, setSaving] = useState(false);

  function set(key: string, value: boolean) {
    setState((prev) => ({ ...prev, [key]: value }));
  }

  function onSave() {
    // Persistence wires to `notification_pref` Supabase table in slice 4.
    setSaving(true);
    setTimeout(() => {
      setSaving(false);
      toast({ tone: 'success', title: 'Preferences saved' });
    }, 400);
  }

  return (
    <div className="space-y-6">
      <Card interactive={false}>
        <header className="border-b border-border px-6 py-3">
          <h3 className="text-sm font-semibold text-navy-primary">Email notifications</h3>
          <p className="mt-0.5 text-xs text-muted-foreground">
            Choose which transactional emails you receive at your billing address.
          </p>
        </header>
        <ul className="divide-y divide-border">
          {PREFS.map((p) => (
            <li key={p.key} className="flex items-start gap-4 px-6 py-4">
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-navy-primary">{p.label}</p>
                <p className="mt-0.5 text-xs text-muted-foreground">{p.description}</p>
              </div>
              <Switch
                checked={state[p.key]}
                onCheckedChange={(v) => set(p.key, v)}
                aria-label={p.label}
              />
            </li>
          ))}
        </ul>
      </Card>

      <div className="flex justify-end">
        <Button onClick={onSave} loading={saving}>
          {saving ? 'Saving…' : 'Save preferences'}
        </Button>
      </div>
    </div>
  );
}
